import AbstractAuthorizationProvider from './AbstractAuthorizationProvider';

export default class NoOpAuthorizationProvider extends AbstractAuthorizationProvider {
	isSignedIn() {
		return false;
	}

	getAuthorizationToken(callback) {
		setTimeout(() => callback(undefined, null), 0);
	}
}
